var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { Inline } from 'syf-component-library/ui/spacing';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { getSpendingTrendsAnalyticsProps } from '../../../../const/analytics/spending-trends';
import { spendingTrendsColors } from '../../../../const/spending-trends';
import { StyledBaseButton } from '../../../../styles/buttons';
import { StyledFlex } from '../../../../styles/common';
import { StyledText, StyledTitle } from '../../../../styles/text';
import { colors } from '../../../../styles/theme';
import TableList from '../../../common/table-list';
import { StyledFontAwesomeIcon } from './subcomponents';
export var RowContent = function (_a) {
    var cellValue = _a.cellValue, _b = _a.textAlign, textAlign = _b === void 0 ? 'left' : _b, _c = _a.fontWeight, fontWeight = _c === void 0 ? 'semiBold' : _c, _d = _a.fontSize, fontSize = _d === void 0 ? 'root' : _d;
    return (_jsx(TableList.Cell, { textAlign: textAlign, children: _jsx(Inset, { left: "base", children: _jsx(StyledText, { color: colors.black, weight: fontWeight, size: fontSize, children: cellValue }) }) }));
};
export var LastColumnHeader = function (_a) {
    var item = _a.item, onClick = _a.onClick, _b = _a.currentSort, currentSort = _b === void 0 ? 'asc' : _b;
    var isDescending = currentSort === 'desc';
    return (_jsx(TableList.ColumnHeader, { background: spendingTrendsColors.backgroundTableHeader, textAlign: "right", whiteSpace: "nowrap", "aria-sort": isDescending ? 'descending' : 'ascending', children: _jsx(StyledTitle, { color: colors.black, children: _jsx(StyledBaseButton, __assign({ onClick: onClick, fontSize: "root", color: "black" }, getSpendingTrendsAnalyticsProps(isDescending).amountSpent, { children: _jsx(Inset, { all: "small", children: _jsxs(StyledFlex, { direction: "row", justifyContent: "flex-end", alignItems: "center", children: [item, _jsx(Inline, { size: "small" }), _jsx(StyledFontAwesomeIcon, { icon: faCaretDown, rotation: isDescending ? 180 : undefined })] }) }) })) }) }));
};
//# sourceMappingURL=index.js.map